import { TimelineCacheClearResponseSchema, TimelineCacheInfoSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type TimelineCacheInfoInput = z.input<typeof TimelineCacheInfoSchema>;
export type TimelineCacheInfoOutput = z.output<typeof TimelineCacheInfoSchema>;

export function serializeTimelineCacheInfo(payload: TimelineCacheInfoInput): TimelineCacheInfoOutput {
  return TimelineCacheInfoSchema.parse(payload);
}

export type TimelineCacheClearResponseInput = z.input<typeof TimelineCacheClearResponseSchema>;
export type TimelineCacheClearResponseOutput = z.output<typeof TimelineCacheClearResponseSchema>;

export function serializeTimelineCacheClearResponse(
  payload: TimelineCacheClearResponseInput
): TimelineCacheClearResponseOutput {
  return TimelineCacheClearResponseSchema.parse(payload);
}
